import { UserMessage } from 'app/types-shared';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { complexValidationFromServer } from 'app/infrastructure/data/validation';
import { ProcessRoleFailed } from './action-types';
import { Dispatch, AnyAction } from 'redux';
import { normalizeValidation } from 'app/components/access-panel/validation';
import { ValidationWire } from 'app/components/access-panel/validation/types';
import { QueryParam } from 'app/area/administration/edit/role/types';
import { ApplicationState } from 'app/types-store';

interface ApiError {
  userMessages: string | UserMessage[];
  validationErrors: ValidationWire<any>;
}

export const dispatchSaveError = (err: ApiError, dispatch: Dispatch<AnyAction>,
  validationErrorText: string, data: QueryParam, getState: () => ApplicationState) => {

  if (err) {

    err.userMessages && err.userMessages.length && dispatch(new ErrorNotification(err.userMessages));
    err.validationErrors && Object.keys(err.validationErrors).length &&
      dispatch(new ErrorNotification(validationErrorText));

    const state = getState().administrationRoleEdit;

    dispatch(new ProcessRoleFailed({
      ...state.validation,
      ...(err.validationErrors
        ? complexValidationFromServer(normalizeValidation(err.validationErrors, data))
        : [])
    }));
  }
};
